<script>
  import kebabcase from 'lodash.kebabcase'
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import TextContentDetail from '@/components/shared/CommonDetail.vue'
  import moment from 'moment'
  export default {
    components: {
      TextContentDetail
    },
    data() {
      return {
        PageInformation: [],
        selectedCategory: '',
        IsLiked: false,
        IsFavorite: false
      }
    },
    computed: {
        ...mapGetters([
            'AppConfig',
            'MainMenuLayout',
            'ActiveCategory',
            'ContentPage',
            'SelectedContenttab',
            'MainMenuList',
            'resource'
        ]),
        SubscriptionModuleId() {
            return this.$f7route.params.Id
        },
        PostCategories() {
          if (this.ContentPage.Parent.PostCategories) {
              let Category = JSON.parse((this.ContentPage.Parent.PostCategories))
              this.selectedCategory = this.SelectedContenttab ? this.selectedCategory || Category[0] : Category[0]
              return Category
          } else {
              let data = [...new Set(this.ContentPage.ContentPages.map(post => post.Category))] // if category not present in parent then find into the post.
              this.selectedCategory = this.SelectedContenttab ? this.selectedCategory || data[0] : data[0]
              return data
          }
        },
        headerElements() {
            let contentData = this.ContentPage
            let headerElements
            if (contentData.Parent.HeaderElements) {
                headerElements = JSON.parse(contentData.Parent.HeaderElements)
            }
            return headerElements
        },
        footerElements() {
            let contentData = this.ContentPage
            let footerElements
            if (contentData.Parent.FooterElements) {
                footerElements = JSON.parse(contentData.Parent.FooterElements)
            }
            return footerElements
        },
        onePost() {
            if (this.ContentPage.ContentPages.length === 1 &&
                this.ContentPage.ContentPages[0].Posts.length === 1) {
                return true
            }
            return false
        },
        headerTitle() {
            if (this.onePost) {
                return this.ContentPage.ContentPages[0].Posts[0].Title
            } else {
                return this.ContentPage.Parent.PageTitle
            }
        },
        onePostDetails() {
            if (this.onePost) {
                return this.ContentPage.ContentPages[0].Posts[0]
            } else {
                return {}
            }
        },
        Favorite() {
            if (Helper.IsValid(this.onePostDetails)) {
                this.IsFavorite = Helper.CheckIsFavorite(this.onePostDetails.Id, this.onePostDetails.ModulesContentPages_Id)
            }
            return this.IsFavorite
        },
        IsLike() {
            if (Helper.IsValid(this.onePostDetails)) {
                this.IsLiked = Helper.convertBoolean(this.onePostDetails.IsLiked)
            }
            return this.IsLiked
        },
        AllowLikes() {
            return Helper.convertBoolean(this.ContentPage.Parent.AllowLikes)
        },
        AllowAddingToFavorites() {
            return Helper.convertBoolean(this.ContentPage.Parent.AllowAddingToFavorites)
        },
        AllowSharing() {
            return Helper.convertBoolean(this.ContentPage.Parent.AllowSharing)
        },
        AllowComments() {
            return Helper.convertBoolean(this.ContentPage.Parent.AllowComments)
        },
        ModuleInfo() {
            return this.MainMenuList.find(module => module.Id === parseInt(this.SubscriptionModuleId))
        },
        randomNo() {
            return Helper.getRandomInt()
        }
    },
    watch: {
      ContentPage: function(ContentPage) {
        this.PageInformation = ContentPage.ContentPages.filter(page => {
          return page.Posts.sort(function(a, b) {
              return a.OrderId - b.OrderId
          })
        })
      },
      SelectedContenttab: function(val, oldVal) {
        this.selectedCategory = val
        if (!this.$f7) return
        this.$f7.tab.show('#tab-' + this.categoryId(val), true)
      }
    },
    created() {
      this.initContentModule(this.SubscriptionModuleId)
      this.PostCategories()
    },
    mounted() {
      if (this.$refs.textContentPage) {
        this.$refs.textContentPage.$on('page:reinit', (event, payload) => {
            this.initContentModule(this.SubscriptionModuleId)
        })
      }
    },
    beforeDestroy() {
      if (this.$refs.textContentPage) {
        this.setActiveCategory('')
        this.$refs.textContentPage.$off('page:reinit', (event, payload) => {
            this.initContentModule(this.SubscriptionModuleId)
        })
      }
      this.$f7.popover.close()
    },
    methods: {
      ...mapActions([
        'loadContentPagesLocalData',
        'loadContentPages',
        'addUpdateLike',
        'shareInformation',
        'setActiveCategory',
        'addMyFavorite',
        'resetContentPageData'
      ]),
      initContentModule(SubscriptionModuleId) {
        this.$showLoader()
        this.resetContentPageData()
        this.loadContentPagesLocalData(SubscriptionModuleId)
        this.loadContentPages(SubscriptionModuleId).then(() => {
          setTimeout(() => {
              if (this.onePost) {
                this.$hideLoader()
                this.$RegisterPageView({
                  'SubscriptionModule_Id': SubscriptionModuleId,
                  'ContentGUID': this.onePostDetails.Id,
                  'ViewType': 2
                })
              } else {
                this.$hideLoader()
                this.$RegisterPageView({
                  'SubscriptionModule_Id': SubscriptionModuleId,
                  'ContentGUID': this.ContentPage.Parent.Id,
                  'ViewType': 1
                })
              }
          }, 1000)
        }).catch(err => {
          console.log('err', err)
          this.$hideLoader()
        })
      },
      infoDetailUrl: function(value) {
        return '/text-content-detail-view/' + this.SubscriptionModuleId + '/' + value
      },
      IsValid: function(value) {
        return Helper.IsValid(value)
      },
      formattedDate: function(value) {
        return Helper.FormattedDateDDMMMMYY(value)
      },
      day: function(value) {
        return Helper.getDateDay(value)
      },
      month: function(value) {
        return Helper.getDateMonth(value)
      },
      media: function(value) {
        if (!Helper.IsNullOrEmpty(value)) {
          return `<div class="cover-background list-cover-image" style="background-image: url(${this.AppConfig.Urls.ContentAssetsBaseUrl + value})"></div>`
        } else {
          return '<div class="cover-background list-cover-image"></div>'
        }
      },
      textInput:function(value) {
          if (!Helper.IsNullOrEmpty(value)) {
          return `<div><span style="padding: 1rem;display: inline-block;vertical-align: middle;">${value}</span></div>`
        } else {
          return ''
        }
      },
      subtitle: function(noOflike, noOfComment) {
        if (this.AllowLikes && this.AllowComments) {
          return '<div class="headerOption__item"><span>' + noOflike + '<span class="icon-dislike-them-color"></span></span> <span>' + noOfComment + '<span class="icon-comment"></span></span></div>'
        } else if (this.AllowLikes) {
          return '<div class="headerOption__item"><span>' + noOflike + '<span class="icon-dislike-them-color"></span></span></div>'
        } else if (this.AllowComments) {
          return '<div class="headerOption__item"><span>' + noOfComment + '<span class="icon-comment"></span></span></div>'
        }
      },
      categoryId: function(value) {
        var result = value.replace(/ /g, "-")
        return result + '' + this.randomNo
      },
      getPageByCategory(category) {
        let posts = this.PageInformation.find(post => post.Category === category)
        return posts ? posts.Posts : []
      },
      categorySelect(category, index) {
        console.log('categorySelect', category, index)
        if (!this.PostCategories.includes(this.ActiveCategory) && index === 0) {
          return true
        }
        if (this.ActiveCategory === category) {
          return true
        } else if (this.ActiveCategory === '' && index === 0) {
          return true
        }
        return false
      },
      onLikeClick() {
        let Like = {
          ModulesContentPages_Id: this.onePostDetails.ModulesContentPages_Id,
          Reference_Id: this.onePostDetails.Id,
          Liked: !Helper.convertBoolean(this.onePostDetails.IsLiked),
          AppGUID: this.AppConfig.AppGUID,
          ContentType: 1,
          NotificationContent: {
            Title: this.onePostDetails.Title,
            ImageName: this.onePostDetails.PostImage,
            Comment: '',
            Navigationurl: this.infoDetailUrl(this.onePostDetails.Id)
          }
        }
        this.addUpdateLike(Like).then(() => {
          this.$f7.notification.create({
            title: Helper.convertBoolean(this.onePostDetails.IsLiked) ? this.resource.likeSuccesTitle : this.resource.disLikeSuccesTitle,
            subtitle: Helper.convertBoolean(this.onePostDetails.IsLiked) ? this.resource.likeSuccesMessage : this.resource.disLikeSuccesMessage,
            cssClass: 'success-notification',
            closeOnClick: true,
            closeTimeout: 3000
          }).open()
        })
      },
      onShareCLick() {
        let Options = {
          appConfig: this.AppConfig,
          moduleId: this.ContentPage.Parent.Module_Id,
          subscriptionModuleId: this.ContentPage.Parent.SubscriptionModule_Id,
          shareId: this.onePostDetails.Id,
          path: Helper.CurrentlocationURL(),
          orderId: 0
        };
        this.shareInformation(Options);
      },
      onFavoriteClick() {
        let favData = {
          Reference_Id: this.onePostDetails.Id,
          ReferenceParent_Id: this.onePostDetails.ModulesContentPages_Id
        }
        this.addMyFavorite(favData)
        this.IsFavorite = Helper.CheckIsFavorite(this.onePostDetails.Id, this.onePostDetails.ModulesContentPages_Id)
      },
      reinit(payload) {
        // console.log('reinit', payload)
      }
    }
  }
</script>
<template>
  <f7-page ref="textContentPage" :page-content="false" :name="'text-content-view-'+ SubscriptionModuleId" v-if="ContentPage">
    <app-header :header="headerTitle" :isShowRightNavBar="!onePost"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1 && !onePost"></app-tab-menu>
    <!-- <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu> -->
    <app-floating-button v-if="onePost && onePostDetails" :ShowLike="AllowLikes" :ShowFavorite="AllowAddingToFavorites" :ShowShare="AllowSharing" :IsLike="IsLike" :IsFavorite="Favorite" :onLikeClick="onLikeClick" :onFavoriteClick="onFavoriteClick" :onShareCLick="onShareCLick"></app-floating-button>
    <div class="backgroundimg"></div>
    <f7-page-content v-if="!onePost && ContentPage.ContentPages">
      <div v-if="headerElements" class="header-section">
        <component v-for="(el,index) in headerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      </div>
      <f7-segmented style="padding: 10px" v-if="PostCategories.length > 1 && PostCategories[0] != ''">
        <f7-button ref="buttontab" v-for="(category,index) in PostCategories" :tab-link="'#tab-'+categoryId(category)" v-if="index < 3" :key="index" :tab-link-active="categorySelect(category, index)">
          {{category}}
        </f7-button>

        <f7-button v-if="PostCategories.length === 4" :tab-link="'#tab-'+categoryId(PostCategories[3])">
          {{PostCategories[3]}}
        </f7-button>

        <f7-button v-if="PostCategories.length > 4" popover-open="#myinfo-popover">
          More
        </f7-button>
      </f7-segmented>
      <f7-popover id="myinfo-popover" v-if="PostCategories.length > 4" class="setProductPopoverScroll right">
        <f7-list>

          <f7-list-button popover-close v-for="(category,index) in PostCategories" v-if="index > 2" :tab-link="'#tab-'+categoryId(category)" :key="index" class="productList">
             {{ category}}
          </f7-list-button>
        </f7-list>
      </f7-popover>
      <f7-tabs v-if="PageInformation.length > 0">
        <f7-tab v-for="(category,index) in PostCategories" :key="index" :id="'tab-'+categoryId(category)" :tab-active="categorySelect(category, index)">

          <f7-list media-list class="list-margin-topBottom-10">

            <f7-list-item v-for="(PostDetails, index1) in getPageByCategory(category)" :key="index1" :link="infoDetailUrl(PostDetails.Id)">
              <!-- :media="media(PostDetails.PostImage)" -->
              <!-- :subtitle="subtitle(PostDetails.PostLikes ? PostDetails.PostLikes : 0,PostDetails.PostComments ? PostDetails.PostComments.length : 0)" -->
              <div v-if="media(PostDetails.PostImage)" slot="media" v-html="media(PostDetails.PostImage)"></div>
              <div v-html="textInput(PostDetails.Title)"></div>
              <div slot="subtitle" v-html="subtitle(PostDetails.PostLikes ? PostDetails.PostLikes : 0,PostDetails.PostComments ? PostDetails.PostComments.length : 0)"></div>
            </f7-list-item>
          </f7-list>
        </f7-tab>
      </f7-tabs>
      <div valign="bottom" v-if="footerElements" class="footer-section">
        <component v-for="(el,index) in footerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      </div>
    </f7-page-content>
    <text-content-detail v-if="onePost && ContentPage.ContentPages" :Parent="ContentPage.Parent" :PostDetails="onePostDetails" :SubscriptionModuleId="SubscriptionModuleId" IsFrom="Content"></text-content-detail>
  </f7-page>
</template>
<style scoped>
  .list-margin-topBottom-10 {
    margin: 10px 0;
  }
  .floating-button-toolbar, .speed-dial{
    bottom: 15px!important;
  }
  .setProductPopoverScroll {
    max-height: 100%;
    overflow-y: auto;
    overflow-x:hidden;
    /* top: 0px !important; */
  }
  .productList {
    border-bottom: 0.1px solid;
    border-radius: unset !important;
  }
  .productList >>> a {
    word-break: break-word;
    text-align: left !important;
    line-height: 21px !important;
    padding: 10px 12px !important;
  }
  .colorchange{
    font-size: 110%;
  }
</style>



// WEBPACK FOOTER //
// src/components/text-content/TextContent.vue